export enum OrderOptionsEnum {
    COFFEE_TO_GO,
    ORDER_AHEAD,
    ORDER_FROM_SHOP,
    POST_EXPRESS_DELIVERY,
    NEIGHBOURHOOD_DELIVERY
}
